require('./bootstrap');

window.Vue = require('vue');
import Vue from 'vue';

// Active Vue router & import routes
import VueRouter from 'vue-router';
Vue.use(VueRouter);
import routes from './routes';
const router = new VueRouter(routes);

router.beforeEach((to, from, next) => {
    document.title = to.meta.title || 'tempLED Produktkonfigurator';
    next();
});
router.afterEach((to) => {
    if (typeof gtag !== 'undefined') {
        gtag('config', window.GA_TRACKING_ID, {
            page_path: to.fullPath,
            app_name: 'tempLED Produktkonfigurator',
            send_page_view: true,
        });
    }
});

// Vuex Store
import store from './store';

// Multilang
import VueI18n from 'vue-i18n';
import languageBundle from '@kirschbaum-development/laravel-translations-loader!@kirschbaum-development/laravel-translations-loader';
Vue.use(VueI18n);

const lang = localStorage.getItem('locale') || 'de';
const i18n = new VueI18n({
    locale: lang,
    messages: languageBundle,
    silentTranslationWarn: true
})



// Sweet alerts 2
import VueSweetalert2 from "vue-sweetalert2";
import 'sweetalert2/dist/sweetalert2.min.css';
Vue.use(VueSweetalert2);

// Vue Select2 https://github.com/godbasin/vue-select2
import Select2 from 'v-select2-component';
Vue.component('Select2', Select2);

// VeeValidate
//import { ValidationProvider, ValidationObserver, extend } from 'vee-validate/dist/vee-validate.full.esm';
import {
    ValidationProvider,
    ValidationObserver,
    localize,
    extend
} from 'vee-validate'
import * as rules from 'vee-validate/dist/rules'
import de from 'vee-validate/dist/locale/de.json'
import en from 'vee-validate/dist/locale/en.json'
// custom Validators
import * as customValidators from './validators';

for (const rule in rules) {
    extend(rule, {
        ...rules[rule],
        message: lang === 'de' ? de.messages[rule] : en.messages[rule]
    });
}

//localize('de', de)
localize(lang, lang === 'de' ? de : en)


// Make Laravel Assets accessible in Vue Components with asset()
Vue.mixin(require('./asset'));

// User Permission Check
import Permissions from './mixins/Permissions';
Vue.mixin(Permissions);

import UpdateNotification from "./mixins/UpdateNotification.vue";
Vue.mixin(UpdateNotification);

import App from './components/App';

// Auth Components
Vue.component('login-form', require('./components/Auth/LoginForm').default);
Vue.component('register-form', require('./components/Auth/RegisterForm').default);
Vue.component('edit-account-form', require('./components/Auth/EditAccountForm').default);
Vue.component('forgot-password-form', require('./components/Auth/ForgotPasswordForm').default);
Vue.component('reset-password-form', require('./components/Auth/ResetPasswordForm').default);

// User Components
Vue.component('show-user-projects', require('./components/Projects/Index').default);
Vue.component('show-user-project', require('./components/Projects/Show').default);


// Luminaire Line Tool
Vue.component('luminaire-line-slider', require('./components/LuminaireLine/Slider').default);
Vue.component('luminaire-line-step-navigation', require('./components/LuminaireLine/StepNavigation').default);
Vue.component('luminaire-line-form-navigation', require('./components/LuminaireLine/FormNavigation').default);
Vue.component('luminaire-line-project-overview', require('./components/LuminaireLine/ProjectOverview').default);
Vue.component('luminaire-selection-tool', require('./components/LuminaireLine/LuminaireSelectionTool').default);
Vue.component('luminaire-line-create-project', require('./components/LuminaireLine/CreateProject').default);
Vue.component('luminaire-line-tool', require('./components/LuminaireLine/LuminaireLineTool').default);

// Buttons
Vue.component('download-dialux-data-button', require('./components/Utils/Buttons/DownloadDialuxDataButton').default);
Vue.component('download-tender-text-button', require('./components/Utils/Buttons/DownloadTenderTextButton').default);
Vue.component('download-excel-button', require('./components/Utils/Buttons/DownloadExcelButton').default);
Vue.component('download-pdf-button', require('./components/Utils/Buttons/DownloadPdfButton').default);
Vue.component('language-dropdown', require('./components/Utils/Buttons/LanguageDropdown').default);

// Errors
Vue.component('display-error-messages', require('./components/Utils/Errors/DisplayErrorMessages').default);

// General Components
Vue.component('pagination', require('laravel-vue-pagination'));

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

// check if user is authenticated on load
store.dispatch('auth/me').then(() => {
    const app = new Vue({
        el: '#app',
        components: { App },
        router: router,
        i18n,
        store,
        render: h => h(App)
    });
})
